"use client";

import { c as _c } from "react/compiler-runtime";
import { ArrowRight } from "lucide-react";
import { useCallback } from "react";
interface PaginationButtonProps {
  hasPrevious?: boolean;
  hasMore?: boolean;
  isLoading: boolean;
  loadPrevious?: () => Promise<void>;
  loadMore?: () => Promise<void>;
  className?: string;
}

// Previous Button Component (matches carousel-buttons style)
export function PreviousButton(t0) {
  const $ = _c(12);
  const {
    hasPrevious,
    isLoading,
    loadPrevious,
    className
  } = t0;
  let t1;
  if ($[0] !== hasPrevious || $[1] !== isLoading || $[2] !== loadPrevious) {
    t1 = async event => {
      event.preventDefault();
      event.stopPropagation();
      if (hasPrevious && !isLoading && loadPrevious) {
        await loadPrevious();
      }
    };
    $[0] = hasPrevious;
    $[1] = isLoading;
    $[2] = loadPrevious;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handlePrevious = t1;
  const t2 = !hasPrevious || isLoading;
  const t3 = className || "relative z-10 text-black border-gray-300 h-10 w-20 rounded-md flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed bg-gray-100/50 hover:bg-gray-200 border touch-manipulation select-none cursor-pointer";
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      pointerEvents: "auto",
      WebkitTouchCallout: "none"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== isLoading) {
    t5 = isLoading ? <div className="w-4 h-4 border-2 border-gray-400 border-t-transparent rounded-full animate-spin" /> : <ArrowRight className="w-4 h-4 rotate-180" />;
    $[5] = isLoading;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== handlePrevious || $[8] !== t2 || $[9] !== t3 || $[10] !== t5) {
    t6 = <button type="button" onClick={handlePrevious} disabled={t2} className={t3} aria-label="Previous item" style={t4}>{t5}</button>;
    $[7] = handlePrevious;
    $[8] = t2;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}

// Next Button Component (matches carousel-buttons style)
export function NextButton(t0) {
  const $ = _c(12);
  const {
    hasMore,
    isLoading,
    loadMore,
    className
  } = t0;
  let t1;
  if ($[0] !== hasMore || $[1] !== isLoading || $[2] !== loadMore) {
    t1 = async event => {
      event.preventDefault();
      event.stopPropagation();
      if (hasMore && !isLoading && loadMore) {
        await loadMore();
      }
    };
    $[0] = hasMore;
    $[1] = isLoading;
    $[2] = loadMore;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleNext = t1;
  const t2 = !hasMore || isLoading;
  const t3 = className || "relative z-10 text-black border-gray-300 h-10 w-20 rounded-md flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed bg-gray-100/50 hover:bg-gray-200 border touch-manipulation select-none cursor-pointer";
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      pointerEvents: "auto",
      WebkitTouchCallout: "none"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== isLoading) {
    t5 = isLoading ? <div className="w-4 h-4 border-2 border-gray-400 border-t-transparent rounded-full animate-spin" /> : <ArrowRight className="w-4 h-4" />;
    $[5] = isLoading;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== handleNext || $[8] !== t2 || $[9] !== t3 || $[10] !== t5) {
    t6 = <button type="button" onClick={handleNext} disabled={t2} className={t3} aria-label="Next item" style={t4}>{t5}</button>;
    $[7] = handleNext;
    $[8] = t2;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}